// removed by extract-text-webpack-plugin
module.exports = {"Slider":"slider__Slider__1IWeJ","ProgressMarker":"slider__ProgressMarker__2ERPQ"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Replayer/slider.css
// module id = 1714
// module chunks = 2